import React from 'react';
export type TabId = 'general' | 'structure' | 'branding' | 'introduction' | 'assessment' | 'dependencies' | 'history';
interface TabNavigationProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
}
export function TabNavigation({
  activeTab,
  onTabChange
}: TabNavigationProps) {
  const tabs: {
    id: TabId;
    label: string;
  }[] = [{
    id: 'general',
    label: 'General'
  }, {
    id: 'structure',
    label: 'Structure'
  }, {
    id: 'branding',
    label: 'Branding'
  }, {
    id: 'introduction',
    label: 'Course Introduction'
  }, {
    id: 'assessment',
    label: 'Summative Assessment'
  }, {
    id: 'dependencies',
    label: 'Dependencies'
  }, {
    id: 'history',
    label: 'History'
  }];
  return <div className="border-b border-gray-200 mb-8 overflow-x-auto" data-id="element-66">
      <nav className="flex space-x-8 min-w-max" aria-label="Tabs" data-id="element-67">
        {tabs.map(tab => <button key={tab.id} onClick={() => onTabChange(tab.id)} className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors
              ${activeTab === tab.id ? 'border-gray-900 text-gray-900' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
            `} aria-current={activeTab === tab.id ? 'page' : undefined} data-id="element-68">
            {tab.label}
          </button>)}
      </nav>
    </div>;
}